<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.addtional_service">
    <div class="full_message">
        {{localService.languageContent.addtional_service.paid_service}}
    </div>
    <div class="full_message" *ngIf="localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
        <button type="button" class="btn btn-primary" style="margin:5px;"
            (click)="onAction(2)">{{localService.languageContent.common.buy_plan}}</button>
    </div>
</div>